import React, { useEffect, useState } from 'react';

import { Collapse, TableCell, TableRow } from '@material-ui/core';

import { IHoleResult } from '../../../../../store/admin/holeResults/store';

import { useAssignResultsState } from '../../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { EditableDistanceFields } from '../../../../common/EditableDistanceFields/EditableDistanceFields';
import { inchesToFeetAndInches } from '../../../../../contrib/Utils/inchesToFeetAndInches';
import { getCTPHoleWinner } from '../../../../admin/EventWizard/Common/AssignResults/Context/Utils/getCTPHoleWinner';
import { ExpandableCTPTableSubRow } from './ExpandableCTPTableSubRow';
import { sortBy } from '../../../../../contrib/sortBy';

interface IProps {
  hole: string;
  index: number;
  onClick: (index: number) => () => void;
  collapsedRow?: number;
}

export const ExpandableCTPTableRow = (props: IProps) => {
  const { hole, index, onClick, collapsedRow } = props;

  const { ctpResults, selectedRoundFormat } = useAssignResultsState();

  const holeResults = ctpResults[Number(hole)];

  const [ctpHoleWinner, setctpHoleWinner] = useState<IHoleResult>();

  const [feet, setFeet] = useState<number>(0);
  const [inches, setInches] = useState<number>(0);

  useEffect(() => {
    if (ctpHoleWinner) {
      const processedDistance = inchesToFeetAndInches(ctpHoleWinner.pinDistance);

      if (processedDistance) {
        setFeet(processedDistance.feet);
        setInches(processedDistance.inches);
      }
    }
  }, [ctpHoleWinner]);

  useEffect(() => {
    if (selectedRoundFormat) {
      const ctpWinner = getCTPHoleWinner(
        ctpResults[Number(hole)],
        selectedRoundFormat.considerFlights,
        selectedRoundFormat.adjustedHandicap
      );

      if (ctpWinner) {
        setctpHoleWinner(ctpWinner);
      }
    }
  }, [ctpResults, hole, selectedRoundFormat]);

  return (
    <>
      <TableRow
        id={`clickableRowResult-${index}`}
        key={`tableRowResult-${index}`}
        onClick={onClick(index)}
      >
        <TableCell className="index">{Number(hole) + 1}</TableCell>

        <TableCell className="playerName">
          {ctpHoleWinner ? `${ctpHoleWinner.userFirstName[0]}. ${ctpHoleWinner.userLastName}` : '-'}
        </TableCell>

        <TableCell className="result">
          {ctpHoleWinner ? <EditableDistanceFields feet={feet} inches={inches} /> : '-'}
        </TableCell>

        <TableCell />
      </TableRow>

      <TableRow className="expandable-row" key={`hiddenTableRow-${index}`}>
        <TableCell
          className="inner-cell"
          colSpan={4}
          classes={{ root: 'leaderboard-row-event-summary' }}
        >
          <Collapse
            className={`collapse-${index}`}
            classes={{
              container: 'leaderboard-collapse',
              wrapperInner: 'leaderboard-collapse__wrapper-inner override'
            }}
            in={collapsedRow === index}
            timeout="auto"
            unmountOnExit={true}
          >
            {sortBy(holeResults, 'asc', 'pinDistance', undefined, true).map(
              (holeResult: IHoleResult) => (
                <ExpandableCTPTableSubRow
                  holeResult={holeResult}
                  key={`collapse-item-${holeResult.userId}`}
                />
              )
            )}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ExpandableCTPTableSubRow;
